import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import { useNavigate } from "react-router-dom";
import ReactModal from 'react-modal';
import axios from "axios";
import config from '../../config/config';
import { useTenant } from "../../context/TenantContext";
import { toast } from 'react-toastify';
import LoggingService from "../../services/LoggingService";
import "../../styles/Auth.css";

const Authorization = () => {
  const navigate = useNavigate();

  // 🌐 Environment selection (new)
  const [environment, setEnvironment] = useState(localStorage.getItem("premiseOrCloud") || "");

  const [activeTab, setActiveTab] = useState("authorization");
  const [authData, setAuthData] = useState({
    baseUrl: "",
    tenantName: "",
    clientId: "",
    refreshToken: "",
    orgUnitId: "",
  });
  const [authMessage, setAuthMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [authDetails, setAuthDetails] = useState(null);
  const isCloud = environment === "cloud";

  const [newTenant, setNewTenant] = useState({ name: "", url: "", tenantId: "" });
  const [editingTenant, setEditingTenant] = useState(null);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [tenantToDelete, setTenantToDelete] = useState(null);
  const { tenants, fetchTenants } = useTenant();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setAuthData({ ...authData, [name]: value });
  };

  const handleEnvironmentChange = (e) => {
    const selected = e.target.value;
    setEnvironment(selected);
    localStorage.setItem("premiseOrCloud", selected);
    setAuthMessage("");
  };

  //   // Add these tenant management functions
//   const addTenant = async () => {
//     if (!newTenant.name || !newTenant.url || !newTenant.tenantId) {
//       LoggingService.logError("Tenant Validation", "Missing required tenant information");
//       toast.error("Please enter Tenant Name, URL, and Tenant ID.");
//       return;
//     }
const addTenant = async () => {
  if (!newTenant.name || !newTenant.url || !newTenant.tenantId) {
    LoggingService.logError("Tenant Validation", "Missing required tenant information");
    toast.error("Please enter Tenant Name, URL, and Tenant ID.");
    return;
  }

  // Format the URL before making the request
  const formattedUrl = newTenant.url.trim();
  
  LoggingService.logAction("Add Tenant", `Attempting to add tenant: ${newTenant.name}`);
  setIsLoading(true);
  try {
    const token = localStorage.getItem("userToken");
    if (!token) {
      toast.error("You must be logged in to add tenants.");
      return;
    }

    const response = await axios.post(
      `${config.API_BASE_URL}/api/orchestrator/tenants`,
      { 
        name: newTenant.name, 
        orch_tenant_url: formattedUrl,
        tenant_id: newTenant.tenantId
      },
      { 
        headers: { 
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      }
    );

    if (response.data.folderCount) {
      toast.success(`${newTenant.name} tenant validated and added successfully! Found ${response.data.folderCount} folders.`);
    } else {
      toast.success(`${newTenant.name} tenant created successfully!`);
    }
    
    setNewTenant({ name: "", url: "", tenantId: "" });
    await fetchTenants();
  } catch (error) {
    LoggingService.logError("Add Tenant Error", `Failed to add tenant ${newTenant.name}: ${error.message}`);
    console.error("Error adding tenant:", error.response?.data || error);
    const errorMessage = error.response?.data?.error || error.message || "Failed to add tenant";
    toast.error(`Failed to add tenant: ${errorMessage}`);
  } finally {
    setIsLoading(false);
  }
};

const startEditing = (tenant) => {
  setEditingTenant({ ...tenant });
};

const saveTenant = async () => {
  if (!editingTenant.name || !editingTenant.orch_tenant_url || !editingTenant.orch_tenant_id) {
    LoggingService.logError("Tenant Update Validation", "Missing required tenant information");
    toast.error("Tenant Name, URL, and ID cannot be empty.");
    return;
  }

  LoggingService.logAction("Update Tenant", `Updating tenant: ${editingTenant.name}`);
  setIsLoading(true);
  try {
    const token = localStorage.getItem("userToken");
    if (!token) {
      toast.error("You must be logged in to update tenants.");
      return;
    }
    await axios.put(
      `${config.API_BASE_URL}/api/orchestrator/tenants/${editingTenant.id}`,
      {
        name: editingTenant.name,
        orch_tenant_url: editingTenant.orch_tenant_url,
        orch_tenant_id: editingTenant.orch_tenant_id
      },
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    toast.success(`${editingTenant.name} tenant updated successfully!`);
    setEditingTenant(null);
    await fetchTenants();
  } catch (error) {
    LoggingService.logError("Update Tenant Error", `Failed to update tenant ${editingTenant.name}: ${error.message}`);
    console.error("Update error:", error.response?.data || error);
    toast.error(error.response?.data?.error || "Failed to update tenant");
  }
  setIsLoading(false);
};

const confirmDelete = (tenant) => {
  setTenantToDelete(tenant);
  setIsDeleteModalOpen(true);
};

const handleDelete = async () => {
  LoggingService.logAction("Delete Tenant", `Attempting to delete tenant: ${tenantToDelete.name}`);
  setIsLoading(true);
  try {
    const token = localStorage.getItem("userToken");
    if (!token) {
      toast.error("You must be logged in to delete tenants.");
      return;
    }

    const response = await axios.delete(
      `${config.API_BASE_URL}/api/orchestrator/tenants/${tenantToDelete.id}`,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );

    if (response.data.message) {
      toast.success(response.data.message);
      await fetchTenants();
    }
  } catch (error) {
    LoggingService.logError("Delete Tenant Error", `Failed to delete tenant ${tenantToDelete.name}: ${error.message}`);
    console.error("Delete error details:", error.response?.data || error);
    toast.error(error.response?.data?.error || "Failed to delete tenant. Please check if there are any dependencies.");
  } finally {
    setIsLoading(false);
    setIsDeleteModalOpen(false);
    setTenantToDelete(null);
  }
};
///// buraya kadar

  const handleAuthorization = async () => {
    LoggingService.logAuth("Authorization Attempt", `Attempting to authorize with base URL: ${authData.baseUrl}`);
    setIsLoading(true);
    setAuthMessage("");

    try {
      const token = localStorage.getItem("userToken");

      if (!token) {
        LoggingService.logAuth("Authorization Failed", "No token available");
        setAuthMessage("Authorization failed: No token available. Please log in again.");
        navigate("/login");
        return;
      }

      const response = await axios.post(
        `${config.API_BASE_URL}/api/orchestrator/authorize`,
        {
          baseUrl: authData.baseUrl || "https://cloud.uipath.com/ucgentr/DefaultTenant",
          clientId: authData.clientId || "default_client_id",
          refreshToken: authData.refreshToken || "default_refresh_token",
          tenantName: authData.tenantName || "DefaultTenant",
          orgUnitId: authData.orgUnitId || "3957884",
          environment_type: environment
          
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      if (response.data.message === "Authorization successful") {
        LoggingService.logAuth("Authorization Success", "Authorization completed successfully");
        setAuthMessage("Authorization successful! Redirecting...");
      localStorage.removeItem("lastAuthMessage");

        setTimeout(() => navigate("/dashboard"), 2000);
      } else {
        LoggingService.logAuth("Authorization Failed", response.data.error || "Unknown error");
        setAuthMessage(response.data.error || "Authorization failed. Please try again.");
      }
    } catch (error) {
      LoggingService.logError("Authorization Error", `Failed to authorize: ${error.message}`);
      console.error("Authorization error:", error);
      setAuthMessage("An error occurred during authorization. Please check your details.");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    const fetchAuthorizationDetails = async () => {
      LoggingService.logSystem("Config Fetch", "Fetching Orchestrator configuration");
      try {
        const token = localStorage.getItem("userToken");

        if (!token) {
          LoggingService.logAuth("Unauthorized", "No token available for config fetch");
          setAuthMessage("Unauthorized: Please log in first.");
          return;
        }

        const response = await axios.get(`${config.API_BASE_URL}/api/orchestrator/config`, {
          headers: { Authorization: `Bearer ${token}` },
        });

        const { base_url, tenant_name } = response.data.config;
        setAuthDetails({ baseUrl: base_url, tenantName: tenant_name });

        // if (!localStorage.getItem("premiseOrCloud") && base_url.includes("cloud.uipath.com")) {
        //   localStorage.setItem("premiseOrCloud", "cloud");
        //   setEnvironment("cloud");
        // }

        if (!localStorage.getItem("premiseOrCloud")) {
          const type = base_url.includes("cloud.uipath.com") ? "cloud" : "premise";
          localStorage.setItem("premiseOrCloud", type);
          setEnvironment(type);
        } else {
          setEnvironment(localStorage.getItem("premiseOrCloud"));
        }
        
        LoggingService.logSystem("Config Success", `Connected to Orchestrator: ${tenant_name}`);
        setAuthMessage(`Connected to Orchestrator: ${tenant_name} (${base_url})`);
        localStorage.setItem("lastAuthMessage", `Connected to Orchestrator: ${tenant_name} (${base_url})`);

      } catch (error) {
        LoggingService.logError("Config Fetch Error", `Failed to fetch config: ${error.message}`);
        console.error("Error fetching authorization details:", error);
        setAuthMessage("Failed to retrieve Orchestrator details. Please reauthorize.");
      }
    };

    fetchAuthorizationDetails();
  }, []);

  // environment dropdown’ı değiştiğinde mesajı geri getirir
  useEffect(() => {
    const currentAuthMessage = localStorage.getItem("lastAuthMessage");
    if (!authMessage && currentAuthMessage) {
      setAuthMessage(currentAuthMessage);
    }
  }, [environment]);
  
  const handleGoBack = () => {
    localStorage.removeItem("premiseOrCloud");
    setEnvironment("");
  };

  return (
    <div className="authorization-container">
      <Helmet>
        <title>Authorization - Autonomie</title>
      </Helmet>

      <div className="tab-container">
        <button
          className={activeTab === "authorization" ? "active" : ""}
          onClick={() => setActiveTab("authorization")}
        >
          Authorization
        </button>
        <button
          className={activeTab === "manageTenants" ? "active" : ""}
          onClick={() => setActiveTab("manageTenants")}
        >
          Manage Tenants
        </button>
      </div>

      {activeTab === "authorization" && (
        <div className="authorization-content">
          <h2>{isCloud ? "Cloud Authorization" : "On-Prem Authorization"}</h2>

          {/* 🌐 Environment Selection */}
          <div className="form-group">
            <label htmlFor="environment">Environment Type</label>
            <select
              id="environment"
              value={environment}
              onChange={handleEnvironmentChange}
              className="select-environment"
            >
              <option value="">-- Select Environment --</option>
              <option value="cloud">Cloud</option>
              <option value="premise">On-Prem</option>
            </select>
          </div>

          {environment && (
            <>
              <div className="form-group">
                <label htmlFor="baseUrl">Base URL</label>
                <input
                  type="text"
                  id="baseUrl"
                  name="baseUrl"
                  value={authData.baseUrl}
                  onChange={handleChange}
                  placeholder="Base URL"
                />
              </div>

              {isCloud && (
                <>
                  <div className="form-group">
                    <label htmlFor="clientId">Client ID</label>
                    <input
                      type="text"
                      id="clientId"
                      name="clientId"
                      value={authData.clientId}
                      onChange={handleChange}
                      placeholder="Client ID"
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="refreshToken">Client Secret</label>
                    <input
                      type="text"
                      id="refreshToken"
                      name="refreshToken"
                      value={authData.refreshToken}
                      onChange={handleChange}
                      placeholder="Client Secret"
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="tenantName">Tenant Name</label>
                    <input
                      type="text"
                      id="tenantName"
                      name="tenantName"
                      value={authData.tenantName}
                      onChange={handleChange}
                      placeholder="Tenant Name"
                    />
                  </div>
                </>
              )}

              <div className="button-group">
                <button onClick={handleAuthorization} disabled={isLoading}>
                  {isLoading ? "Authorizing..." : "Authorize"}
                </button>
                <button onClick={handleGoBack} disabled={isLoading}>
                  Reset
                </button>
              </div>
            </>
          )}

          {authMessage && (
            <p className={`auth-message ${authMessage.includes("failed") ? "error" : "success"}`}>
              {authMessage}
            </p>
          )}
        </div>
      )}

      {/* Remaining code for tenant management stays unchanged */}

      {activeTab === "manageTenants" && (
        <div className="tenant-management">
          <h3>Manage Tenants</h3>
          <div className="add-tenant">
            <input
              type="text"
              placeholder="Tenant Name"
              value={newTenant.name}
              onChange={(e) => setNewTenant({ ...newTenant, name: e.target.value })}
            />
            <input
              type="text"
              placeholder="Tenant URL"
              value={newTenant.url}
              onChange={(e) => setNewTenant({ ...newTenant, url: e.target.value })}
            />
            <input
              type="text"
              placeholder="Tenant ID"
              value={newTenant.tenantId}
              onChange={(e) => setNewTenant({ ...newTenant, tenantId: e.target.value })}
            />
            <button onClick={addTenant} disabled={isLoading}>
              {isLoading ? "Adding..." : "Add Tenant"}
            </button>
          </div>
  
          <div className="tenant-list">
            {tenants.map((tenant) => (
              <div key={tenant.id} className="tenant-card">
                <div className="tenant-header">
                  {editingTenant?.id === tenant.id ? (
                    <div className="editing-form">
                      <input
                        type="text"
                        value={editingTenant.name}
                        onChange={(e) =>
                          setEditingTenant({ ...editingTenant, name: e.target.value })
                        }
                        placeholder="Tenant Name"
                      />
                      <input
                        type="text"
                        value={editingTenant.orch_tenant_id}
                        onChange={(e) =>
                          setEditingTenant({
                            ...editingTenant,
                            orch_tenant_id: e.target.value,
                          })
                        }
                        placeholder="Tenant ID"
                      />
                      <input
                        type="text"
                        value={editingTenant.orch_tenant_url}
                        onChange={(e) =>
                          setEditingTenant({
                            ...editingTenant,
                            orch_tenant_url: e.target.value,
                          })
                        }
                        placeholder="Tenant URL"
                      />
                      <div className="edit-actions">
                        <button className="icon-btn" onClick={saveTenant}>✅</button>
                        <button className="icon-btn" onClick={() => setEditingTenant(null)}>❌</button>
                      </div>
                    </div>
                  ) : (
                    <>
                      <span className="tenant-name">{tenant.name}</span>
                      <span className="tenant-orch-id"> ID: {tenant.orch_tenant_id}</span>
                      <div className="tenant-actions">
                        <button
                          className="icon-btn"
                          onClick={() => startEditing(tenant)}
                        >
                          ✏️
                        </button>
                        <button
                          className="icon-btn delete-btn"
                          onClick={() => confirmDelete(tenant)}
                          disabled={isLoading}
                        >
                          🗑️
                        </button>
                      </div>
                    </>
                  )}
                </div>
  
                <div className="tenant-url">
                  <span className="url-icon">🔗</span>
                  <a
                    href={tenant.orch_tenant_url}
                    target="_blank"
                    rel="noopener noreferrer"
                    title={tenant.orch_tenant_url}
                  >
                    {tenant.orch_tenant_url.length > 30
                      ? tenant.orch_tenant_url.substring(0, 30) + "..."
                      : tenant.orch_tenant_url}
                  </a>
                </div>
              </div>
            ))}
          </div>
  
          <ReactModal
            isOpen={isDeleteModalOpen}
            onRequestClose={() => setIsDeleteModalOpen(false)}
            className="delete-modal"
            overlayClassName="delete-modal-overlay"
          >
            <div className="delete-modal-content">
              <h3>Confirm Deletion</h3>
              <p>Are you sure you want to delete tenant "{tenantToDelete?.name}"?</p>
              <p>This action cannot be undone.</p>
              <div className="button-group">
                <button
                  className="delete-btn"
                  onClick={handleDelete}
                  disabled={isLoading}
                >
                  {isLoading ? "Deleting..." : "Delete"}
                </button>
                <button
                  className="cancel-btn"
                  onClick={() => setIsDeleteModalOpen(false)}
                  disabled={isLoading}
                >
                  Cancel
                </button>
              </div>
            </div>
          </ReactModal>
        </div>
      )}
    </div>
  );
  
};

export default Authorization;


//////////////////////////////


// import React, { useState, useEffect } from "react";
// import { Helmet } from "react-helmet";
// import { useNavigate } from "react-router-dom";
// import ReactModal from 'react-modal';
// import axios from "axios";
// import config from '../../config/config';
// import { useTenant } from "../../context/TenantContext";
// import { toast } from 'react-toastify';
// import LoggingService from "../../services/LoggingService";
// import "../../styles/Auth.css";

// const Authorization = () => {
//   const navigate = useNavigate();
  
//   // All state declarations at the top
//   const [activeTab, setActiveTab] = useState("authorization");
//   const [authData, setAuthData] = useState({
//     baseUrl: "",
//     tenantName: "",
//     clientId: "",
//     refreshToken: "",
//     orgUnitId: "",
//   });
//   const [authMessage, setAuthMessage] = useState("");
//   const [isLoading, setIsLoading] = useState(false);
//   const [authDetails, setAuthDetails] = useState(null);
//   const isCloud = localStorage.getItem("premiseOrCloud") === "cloud";

//   // Tenant management states
//   // Update the state to include tenantId
//   const [newTenant, setNewTenant] = useState({ name: "", url: "", tenantId: "" });
//   const [editingTenant, setEditingTenant] = useState(null);
//   const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
//   const [tenantToDelete, setTenantToDelete] = useState(null);
//   const { tenants, fetchTenants } = useTenant();

//   // All functions before the return statement
//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setAuthData({ ...authData, [name]: value });
//   };

//   const handleAuthorization = async () => {
//     LoggingService.logAuth("Authorization Attempt", `Attempting to authorize with base URL: ${authData.baseUrl}`);
//     setIsLoading(true);
//     setAuthMessage("");

//     try {
//       const token = localStorage.getItem("userToken");

//       if (!token) {
//         LoggingService.logAuth("Authorization Failed", "No token available");
//         setAuthMessage("Authorization failed: No token available. Please log in again.");
//         navigate("/login");
//         return;
//       }

//       const response = await axios.post(
//         `${config.API_BASE_URL}/api/orchestrator/authorize`,
//         {
//           //baseUrl: authData.baseUrl || "https://cloud.uipath.com/test_cloudorganization/DefaultTenant",
//           baseUrl: authData.baseUrl || "https://cloud.uipath.com/ucgentr/DefaultTenant",
//           clientId: authData.clientId || "default_client_id",
//           refreshToken: authData.refreshToken || "default_refresh_token",
//           tenantName: authData.tenantName || "DefaultTenant",
//           orgUnitId: authData.orgUnitId || "3957884",
//         },
//         {
//           headers: { Authorization: `Bearer ${token}` },
//         }
//       );

//       if (response.data.message === "Authorization successful") {
//         LoggingService.logAuth("Authorization Success", "Authorization completed successfully");
//         setAuthMessage("Authorization successful! Redirecting...");
//         setTimeout(() => navigate("/dashboard"), 2000);
//       } else {
//         LoggingService.logAuth("Authorization Failed", response.data.error || "Unknown error");
//         setAuthMessage(response.data.error || "Authorization failed. Please try again.");
//       }
//     } catch (error) {
//       LoggingService.logError("Authorization Error", `Failed to authorize: ${error.message}`);
//       console.error("Authorization error:", error);
//       setAuthMessage("An error occurred during authorization. Please check your details.");
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   // Fetch existing authorization details - on prem cloud karisikligi
//   // useEffect(() => {
//   //   const fetchAuthorizationDetails = async () => {
//   //     LoggingService.logSystem("Config Fetch", "Fetching Orchestrator configuration");
//   //     try {
//   //       const token = localStorage.getItem("userToken");

//   //       if (!token) {
//   //         LoggingService.logAuth("Unauthorized", "No token available for config fetch");
//   //         setAuthMessage("Unauthorized: Please log in first.");
//   //         return;
//   //       }

//   //       const response = await axios.get(`${config.API_BASE_URL}/api/orchestrator/config`, {
//   //         headers: { Authorization: `Bearer ${token}` },
//   //       });

//   //       const { base_url, tenant_name } = response.data.config;
//   //       setAuthDetails({ baseUrl: base_url, tenantName: tenant_name });
//   //       LoggingService.logSystem("Config Success", `Connected to Orchestrator: ${tenant_name}`);
//   //       setAuthMessage(`Connected to Orchestrator: ${tenant_name} (${base_url})`);
//   //     } catch (error) {
//   //       LoggingService.logError("Config Fetch Error", `Failed to fetch config: ${error.message}`);
//   //       console.error("Error fetching authorization details:", error);
//   //       setAuthMessage("Failed to retrieve Orchestrator details. Please reauthorize.");
//   //     }
//   //   };

//   //   fetchAuthorizationDetails();
//   // }, []);
//   useEffect(() => {
//     const fetchAuthorizationDetails = async () => {
//       LoggingService.logSystem("Config Fetch", "Fetching Orchestrator configuration");
//       try {
//         const token = localStorage.getItem("userToken");
  
//         if (!token) {
//           LoggingService.logAuth("Unauthorized", "No token available for config fetch");
//           setAuthMessage("Unauthorized: Please log in first.");
//           return;
//         }
  
//         const response = await axios.get(`${config.API_BASE_URL}/api/orchestrator/config`, {
//           headers: { Authorization: `Bearer ${token}` },
//         });
  
//         const { base_url, tenant_name } = response.data.config;
//         setAuthDetails({ baseUrl: base_url, tenantName: tenant_name });
  
//         // 🔽 Eğer cloud bağlantısı yapılmış ama localStorage'da "premiseOrCloud" yoksa, otomatik olarak ayarla
//         if (!localStorage.getItem("premiseOrCloud") && base_url.includes("cloud.uipath.com")) {
//           localStorage.setItem("premiseOrCloud", "cloud");
//         }
  
//         LoggingService.logSystem("Config Success", `Connected to Orchestrator: ${tenant_name}`);
//         setAuthMessage(`Connected to Orchestrator: ${tenant_name} (${base_url})`);
//       } catch (error) {
//         LoggingService.logError("Config Fetch Error", `Failed to fetch config: ${error.message}`);
//         console.error("Error fetching authorization details:", error);
//         setAuthMessage("Failed to retrieve Orchestrator details. Please reauthorize.");
//       }
//     };
  
//     fetchAuthorizationDetails();
//   }, []);
  
//   const handleGoBack = () => {
//     localStorage.removeItem("premiseOrCloud");
//     navigate("/premise-or-cloud");
//   };

//   // Add these tenant management functions
//   const addTenant = async () => {
//     if (!newTenant.name || !newTenant.url || !newTenant.tenantId) {
//       LoggingService.logError("Tenant Validation", "Missing required tenant information");
//       toast.error("Please enter Tenant Name, URL, and Tenant ID.");
//       return;
//     }

//     // Format the URL before making the request
//     const formattedUrl = newTenant.url.trim();
    
//     LoggingService.logAction("Add Tenant", `Attempting to add tenant: ${newTenant.name}`);
//     setIsLoading(true);
//     try {
//       const token = localStorage.getItem("userToken");
//       if (!token) {
//         toast.error("You must be logged in to add tenants.");
//         return;
//       }

//       const response = await axios.post(
//         `${config.API_BASE_URL}/api/orchestrator/tenants`,
//         { 
//           name: newTenant.name, 
//           orch_tenant_url: formattedUrl,
//           tenant_id: newTenant.tenantId
//         },
//         { 
//           headers: { 
//             Authorization: `Bearer ${token}`,
//             'Content-Type': 'application/json'
//           }
//         }
//       );

//       if (response.data.folderCount) {
//         toast.success(`${newTenant.name} tenant validated and added successfully! Found ${response.data.folderCount} folders.`);
//       } else {
//         toast.success(`${newTenant.name} tenant created successfully!`);
//       }
      
//       setNewTenant({ name: "", url: "", tenantId: "" });
//       await fetchTenants();
//     } catch (error) {
//       LoggingService.logError("Add Tenant Error", `Failed to add tenant ${newTenant.name}: ${error.message}`);
//       console.error("Error adding tenant:", error.response?.data || error);
//       const errorMessage = error.response?.data?.error || error.message || "Failed to add tenant";
//       toast.error(`Failed to add tenant: ${errorMessage}`);
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const startEditing = (tenant) => {
//     setEditingTenant({ ...tenant });
//   };

//   const saveTenant = async () => {
//     if (!editingTenant.name || !editingTenant.orch_tenant_url || !editingTenant.orch_tenant_id) {
//       LoggingService.logError("Tenant Update Validation", "Missing required tenant information");
//       toast.error("Tenant Name, URL, and ID cannot be empty.");
//       return;
//     }

//     LoggingService.logAction("Update Tenant", `Updating tenant: ${editingTenant.name}`);
//     setIsLoading(true);
//     try {
//       const token = localStorage.getItem("userToken");
//       if (!token) {
//         toast.error("You must be logged in to update tenants.");
//         return;
//       }
//       await axios.put(
//         `${config.API_BASE_URL}/api/orchestrator/tenants/${editingTenant.id}`,
//         {
//           name: editingTenant.name,
//           orch_tenant_url: editingTenant.orch_tenant_url,
//           orch_tenant_id: editingTenant.orch_tenant_id
//         },
//         {
//           headers: { Authorization: `Bearer ${token}` },
//         }
//       );
//       toast.success(`${editingTenant.name} tenant updated successfully!`);
//       setEditingTenant(null);
//       await fetchTenants();
//     } catch (error) {
//       LoggingService.logError("Update Tenant Error", `Failed to update tenant ${editingTenant.name}: ${error.message}`);
//       console.error("Update error:", error.response?.data || error);
//       toast.error(error.response?.data?.error || "Failed to update tenant");
//     }
//     setIsLoading(false);
//   };

//   const confirmDelete = (tenant) => {
//     setTenantToDelete(tenant);
//     setIsDeleteModalOpen(true);
//   };

//   const handleDelete = async () => {
//     LoggingService.logAction("Delete Tenant", `Attempting to delete tenant: ${tenantToDelete.name}`);
//     setIsLoading(true);
//     try {
//       const token = localStorage.getItem("userToken");
//       if (!token) {
//         toast.error("You must be logged in to delete tenants.");
//         return;
//       }

//       const response = await axios.delete(
//         `${config.API_BASE_URL}/api/orchestrator/tenants/${tenantToDelete.id}`,
//         {
//           headers: { Authorization: `Bearer ${token}` },
//         }
//       );

//       if (response.data.message) {
//         toast.success(response.data.message);
//         await fetchTenants();
//       }
//     } catch (error) {
//       LoggingService.logError("Delete Tenant Error", `Failed to delete tenant ${tenantToDelete.name}: ${error.message}`);
//       console.error("Delete error details:", error.response?.data || error);
//       toast.error(error.response?.data?.error || "Failed to delete tenant. Please check if there are any dependencies.");
//     } finally {
//       setIsLoading(false);
//       setIsDeleteModalOpen(false);
//       setTenantToDelete(null);
//     }
//   };

//   return (
//     <div className="authorization-container">
//       <Helmet>
//         <title>Authorization - Autonomie</title>
//       </Helmet>

//       <div className="tab-container">
//         <button
//           className={activeTab === "authorization" ? "active" : ""}
//           onClick={() => setActiveTab("authorization")}
//         >
//           Authorization
//         </button>
//         <button
//           className={activeTab === "manageTenants" ? "active" : ""}
//           onClick={() => setActiveTab("manageTenants")}
//         >
//           Manage Tenants
//         </button>
//       </div>

//       {activeTab === "authorization" && (
//         <div className="authorization-content">
//           <h2>{isCloud ? "Cloud Authorization" : "On-Prem Authorization"}</h2>
  
//           {authDetails === null && <p>Loading Orchestrator details...</p>}
          
//           <div className="form-group">
//             <label htmlFor="baseUrl">Base URL</label>
//             <input
//               type="text"
//               id="baseUrl"
//               name="baseUrl"
//               value={authData.baseUrl}
//               onChange={handleChange}
//               placeholder="Base URL"
//             />
//           </div>
  
//           {isCloud && (
//             <>
//               <div className="form-group">
//                 <label htmlFor="clientId">Client ID</label>
//                 <input
//                   type="text"
//                   id="clientId"
//                   name="clientId"
//                   value={authData.clientId}
//                   onChange={handleChange}
//                   placeholder="Client ID"
//                 />
//               </div>
//               <div className="form-group">
//                 <label htmlFor="refreshToken">Refresh Token</label>
//                 <input
//                   type="text"
//                   id="refreshToken"
//                   name="refreshToken"
//                   value={authData.refreshToken}
//                   onChange={handleChange}
//                   placeholder="Refresh Token"
//                 />
//               </div>
//               <div className="form-group">
//                 <label htmlFor="tenantName">Tenant Name</label>
//                 <input
//                   type="text"
//                   id="tenantName"
//                   name="tenantName"
//                   value={authData.tenantName}
//                   onChange={handleChange}
//                   placeholder="Tenant Name"
//                 />
//               </div>
//             </>
//           )}
  
//           <div className="button-group">
//             <button onClick={handleAuthorization} disabled={isLoading}>
//               {isLoading ? "Authorizing..." : "Authorize"}
//             </button>
//             <button onClick={handleGoBack} disabled={isLoading}>
//               Go Back
//             </button>
//           </div>
  
//           {authMessage && (
//             <p
//               className={`auth-message ${
//                 authMessage.includes("failed") ? "error" : "success"
//               }`}
//             >
//               {authMessage}
//             </p>
//           )}
//         </div>
//       )}

//       {activeTab === "manageTenants" && (
//         <div className="tenant-management">
//           <h3>Manage Tenants</h3>
//           <div className="add-tenant">
//             <input
//               type="text"
//               placeholder="Tenant Name"
//               value={newTenant.name}
//               onChange={(e) => setNewTenant({ ...newTenant, name: e.target.value })}
//             />
//             <input
//               type="text"
//               placeholder="Tenant URL"
//               value={newTenant.url}
//               onChange={(e) => setNewTenant({ ...newTenant, url: e.target.value })}
//             />
//             <input
//               type="text"
//               placeholder="Tenant ID"
//               value={newTenant.tenantId}
//               onChange={(e) => setNewTenant({ ...newTenant, tenantId: e.target.value })}
//             />
//             <button onClick={addTenant} disabled={isLoading}>
//               {isLoading ? "Adding..." : "Add Tenant"}
//             </button>
//           </div>
  
//           <div className="tenant-list">
//             {tenants.map((tenant) => (
//               <div key={tenant.id} className="tenant-card">
//                 <div className="tenant-header">
//                   {editingTenant?.id === tenant.id ? (
//                     <div className="editing-form">
//                       <input
//                         type="text"
//                         value={editingTenant.name}
//                         onChange={(e) =>
//                           setEditingTenant({ ...editingTenant, name: e.target.value })
//                         }
//                         placeholder="Tenant Name"
//                       />
//                       <input
//                         type="text"
//                         value={editingTenant.orch_tenant_id}
//                         onChange={(e) =>
//                           setEditingTenant({
//                             ...editingTenant,
//                             orch_tenant_id: e.target.value,
//                           })
//                         }
//                         placeholder="Tenant ID"
//                       />
//                       <input
//                         type="text"
//                         value={editingTenant.orch_tenant_url}
//                         onChange={(e) =>
//                           setEditingTenant({
//                             ...editingTenant,
//                             orch_tenant_url: e.target.value,
//                           })
//                         }
//                         placeholder="Tenant URL"
//                       />
//                       <div className="edit-actions">
//                         <button className="icon-btn" onClick={saveTenant}>✅</button>
//                         <button className="icon-btn" onClick={() => setEditingTenant(null)}>❌</button>
//                       </div>
//                     </div>
//                   ) : (
//                     <>
//                       <span className="tenant-name">{tenant.name}</span>
//                       <span className="tenant-orch-id"> ID: {tenant.orch_tenant_id}</span>
//                       <div className="tenant-actions">
//                         <button
//                           className="icon-btn"
//                           onClick={() => startEditing(tenant)}
//                         >
//                           ✏️
//                         </button>
//                         <button
//                           className="icon-btn delete-btn"
//                           onClick={() => confirmDelete(tenant)}
//                           disabled={isLoading}
//                         >
//                           🗑️
//                         </button>
//                       </div>
//                     </>
//                   )}
//                 </div>
  
//                 <div className="tenant-url">
//                   <span className="url-icon">🔗</span>
//                   <a
//                     href={tenant.orch_tenant_url}
//                     target="_blank"
//                     rel="noopener noreferrer"
//                     title={tenant.orch_tenant_url}
//                   >
//                     {tenant.orch_tenant_url.length > 30
//                       ? tenant.orch_tenant_url.substring(0, 30) + "..."
//                       : tenant.orch_tenant_url}
//                   </a>
//                 </div>
//               </div>
//             ))}
//           </div>
  
//           <ReactModal
//             isOpen={isDeleteModalOpen}
//             onRequestClose={() => setIsDeleteModalOpen(false)}
//             className="delete-modal"
//             overlayClassName="delete-modal-overlay"
//           >
//             <div className="delete-modal-content">
//               <h3>Confirm Deletion</h3>
//               <p>Are you sure you want to delete tenant "{tenantToDelete?.name}"?</p>
//               <p>This action cannot be undone.</p>
//               <div className="button-group">
//                 <button
//                   className="delete-btn"
//                   onClick={handleDelete}
//                   disabled={isLoading}
//                 >
//                   {isLoading ? "Deleting..." : "Delete"}
//                 </button>
//                 <button
//                   className="cancel-btn"
//                   onClick={() => setIsDeleteModalOpen(false)}
//                   disabled={isLoading}
//                 >
//                   Cancel
//                 </button>
//               </div>
//             </div>
//           </ReactModal>
//         </div>
//       )}
//     </div>
//   );
// };

// export default Authorization;
